import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { AuthResourceService } from '@mri/app/resources';

@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {
  constructor(private _authSrv: AuthResourceService) {}

  intercept(request: HttpRequest<string>, next: HttpHandler): Observable<HttpEvent<string>> {
    // add auth header with jwt if user is logged in and request is to the api url
    const currentUser = this._authSrv.auth;
    const isLoggedIn = currentUser && currentUser.session;
    const isApiUrl = request.url.startsWith(environment.apiUrl);
    if (isLoggedIn && isApiUrl) {
      request = request.clone({
        setHeaders: this._authSrv.header
      });
    }

    return next.handle(request);
  }
}
